module.exports = __webpack_public_path__ + "img/o_13.00781b8c.png";